import moment from 'moment';

export function getExpirationTranslation(expiryDate: string): Translation {
    const timeLeft = moment(expiryDate).diff(moment().startOf('day'));
    const duration = moment.duration(timeLeft);

    if (duration.years() > 100) {
        return { key: 'EXPIRY.NEVER' };
    }
    if (duration.years() || duration.months() > 1) {
        return {
            key: 'EXPIRY.MONTHS',
            substitutionData: {
                months: duration.years() * 12 + duration.months()
            }
        };
    }
    if (duration.months()) {
        return { key: 'EXPIRY.ONE_MONTH' };
    }

    if (duration.days() && duration.days() < 0) {
        return { key: 'EXPIRY.EXPIRED', substitutionData: { days: 30 - Math.abs(duration.days()) } };
    }

    if (duration.days()) {
        return { key: 'EXPIRY.LESS_THAN_A_MONTH' };
    }

    return { key: 'EXPIRY.TODAY' };
}

export function isValidUntilForever(expiryDate: string): boolean {
    const timeLeft = moment(expiryDate).diff(moment());
    const years = moment.duration(timeLeft).years();

    return years > 100;
}

export function getExpirationDate(expiryDate: Partial<{ date: Date; never: boolean }>): -1 | string {
    if (expiryDate.never === true) {
        return -1;
    }
    if (expiryDate.date !== null) {
        return expiryDate.date.toISOString();
    }
    return null;
}

export function getValidFromDate(validFromDate?: Date): string {
    const date = validFromDate ? validFromDate : new Date();
    return moment(date).startOf('day').toISOString();
}

export function isNew(date: string): boolean {
    const tenDaysAgo = moment().subtract(10, 'days').startOf('day');
    const fileCreatedAt = moment(date).startOf('day');

    return fileCreatedAt >= tenDaysAgo;
}

export function formatDate(date: any, format: string): string {
    // The moment(date).isValid() will return true when the date is undefined
    if (moment(date).isValid()) {
        return moment(date).format(format);
    }

    return '-';
}

export function getISOStringDateFromInput(inputValue: string, separatorChar = '/') {
    if (!inputValue) {
        return '';
    }
    const [day, month, year] = inputValue.split(separatorChar);
    const dateISOString = `${year}-${month}-${day}`;

    return Number.isNaN(new Date(dateISOString).getTime()) ? '' : dateISOString;
}

export function addDiffTime(date: Date, field: 'minute' | 'hour' | 'day' | 'month' | 'year', amount: number) {
    switch (field) {
        case 'minute':
            date.setMinutes(date.getMinutes() + amount);
            break;
        case 'hour':
            date.setHours(date.getHours() + amount);
            break;
        case 'day':
            date.setDate(date.getDate() + amount);
            break;
        case 'month':
            date.setMonth(date.getMonth() + amount);
            break;
        case 'year':
            date.setFullYear(date.getFullYear() + amount);
            break;
    }
    return date;
}

export function isExpired(expiryDate: string): boolean {
    const timeLeft = moment(expiryDate).diff(moment().startOf('day'));
    return moment.duration(timeLeft).days() < 0;
}

export function formatDateToRelativeString(date: string): string {
    const now = moment();
    const targetDate = moment(date);

    if (targetDate.isSame(now, 'day')) {
        return 'Today';
    } else if (targetDate.isSame(now.clone().add(1, 'day'), 'day')) {
        return 'Tomorrow';
    } else if (targetDate.isSame(now.clone().subtract(1, 'day'), 'day')) {
        return 'Yesterday';
    } else if (targetDate.isSame(now, 'year')) {
        return targetDate.format('MMMM Do');
    } else {
        return targetDate.format('MMMM Do, YYYY');
    }
}

interface Translation {
    key: string;
    substitutionData?: any;
}
